<app-generic-toolbar id="toolbar" class="toolbar"
    [toolbarType]="toolbarType"
    [toolbarOptions]="toolbarOptions"
    (propagateEvent)="executeToolbarOption($event)"
    [isFullScreen]="isFullScreen"
    [ngStyle]="{'height': cvToolbarHeight + 'px'}"
></app-generic-toolbar>
<div id="kimera-openseadragon-container" class="openseadragon-viewer"></div>
